<ng-container *ngIf="visible">
    <div class="fixed top-0 right-0 bottom-0 left-0 w-screen h-screen flex justify-center items-center bg-black z-[9999] font-inter">
            <div class="absolute w-full px-[32px] top-[40px] flex justify-between">
                <div class="w-1/3"></div>
                <div class="text-[18px] text-center w-1/3 text-white font-normal">
                    {{activeIndex + 1}} / {{ media.length }}
                </div>
                <div class="w-1/3 flex justify-end">
                    <div class="cursor-pointer max-h-[56px] max-w-[36px] min-w-[56px] z-[10000] text-white"
                        (click)="onclose()">
                        <i class="sctr-icon-x-close text-[32px] text-white font-normal"></i>
                    </div>
                </div>
            </div>
            <div class="absolute w-full justify-between item-navigator px-[32px] items-center z-10 flex text-[44px] pointer-events-none">
                <div 
                    [ngClass]="activeIndex === 0 ? 'text-palette-gray-400 opacity-40 cursor-default': 'text-white cursor-pointer'"
                    class="sctr-icon-chevron-left pointer-events-auto"
                    (click)="prev()">
                </div>
                <div
                    [ngClass]="activeIndex == media.length - 1 ? 'text-palette-gray-400 opacity-40 cursor-default': 'text-white cursor-pointer'"
                    class="sctr-icon-chevron-right pointer-events-auto" (click)="next()"></div>
            </div>
            <div>
                <div>
                    <div class="image-item flex justify-center items-center content-center" (wheel)="onMouseWheelImage($event)" >
                        <div class="max-[800px] max-[500px]" *ngIf="!isServer">
                            <img 
                                *ngIf="isImage(media[activeIndex].file)"
                                [src]="media[activeIndex].url"
                                class="object-center object-contain max-w-[800px] max-h-[500px]"/>
                            <video 
                                *ngIf="isVideo(media[activeIndex].file)"
                                [src]="media[activeIndex].url" controls
                                class="w-[800px] h-[500px]">
                            </video>
                        </div>
                        <div class="max-w-[800px] max-h-[500px]" *ngIf="isServer">
                            <img 
                                *ngIf="isImage(media[activeIndex])" 
                                src="{{baseImageId}}/{{media[activeIndex].id}}.webp"
                                (error)="replaceWithDefaultImage($event)"
                                class="object-center object-contain max-w-[800px] max-h-[500px]"/>
                            <video
                                *ngIf="isVideo(media[activeIndex])" 
                                src="{{baseStreamVideo}}/{{media[activeIndex].id}}{{media[activeIndex].extension}}"
                                controls
                                class="w-[800px] h-[500px]">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute bottom-6">
                <div class="flex justify-center">
                    <div class="max-w-[100vw] flex space-x-1 mt-[90px] overflow-hidden">
                        <div class="w-[100px] h-[100px] border" [ngClass]="{'border-[3px] border-white': idx === activeIndex}" *ngFor="let item of media; index as idx">
                            <div id="image-{{idx}}" (click)="handleImageScroll(idx)" class="rounded-sm cursor-pointer"
                                [ngClass]="idx == activeIndex ? 'p-galleria-thumbnail-item-current':''">
                                <div *ngIf="!isServer">
                                    <img 
                                        *ngIf="isImage(item.file)"
                                        [src]="item.url"
                                        class="object-center object-contain w-[100px] h-[100px]"/>
                                    <video 
                                        *ngIf="isVideo(item.file)"
                                        [src]="item.url"
                                        class="w-[100px] h-[100px]">
                                    </video>
                                </div>
                                <div *ngIf="isServer">
                                    <img 
                                        *ngIf="isImage(item)" 
                                        src="{{baseImageId}}/{{item.id}}.webp"
                                        (error)="replaceWithDefaultImage($event)"
                                        class="object-center object-contain w-[100px] h-[100px] "/>
                                    <video
                                        *ngIf="isVideo(item)" 
                                        src="{{baseStreamVideo}}/{{item.id}}{{item.extension}}"
                                        class="w-[100px] h-[100px]">
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
</ng-container>
    
    
    